
export let configList3 = [
    {
        key: 'model1', name: '2025款 畅享版', Arr: [{
            key: 'base',
            name: '基础参数',
            items: [
                { name: '4980' },
                { name: '1862' },
                { name: '1449' },
                { name: '2830' },
                { name: '1591' },
                { name: '1603' },
                { name: '110' },
                { name: '1495' },
            ],
        },
        {
            key: 'power',
            name: '动力系统',
            items: [
                { name: 'L15BN' },       // 发动机型号
                { name: '1498' },        // 排量(mL)
                { name: '涡轮增压' },     // 进气形式
                { name: '192' },         // 最大马力(Ps)
                { name: '260' },         // 最大扭矩(N·m)
                { name: 'CVT无级变速' },  // 变速箱类型
                { name: '无级变速' },     // 挡位个数
                { name: '前置前驱' },     // 驱动方式
                { name: '-' },           // 四驱形式 (无)
                { name: '-' },           // 中央差速器结构 (无)
            ],
        },
        {
            key: 'chassis',
            name: '底盘转向',
            items: [
                { name: '麦弗逊式独立悬架' },    // 前悬挂类型
                { name: '多连杆式独立悬架' },    // 后悬挂类型
                { name: '电动助力' },            // 助力类型
                { name: '承载式' },              // 车体结构
                { name: '通风盘式' },            // 前制动器类型
                { name: '盘式' },               // 后制动器类型
            ],
        },
        {
            key: 'wheel',
            name: '车轮制动',
            items: [
                { name: '235/45 R18' },   // 前轮胎规格
                { name: '235/45 R18' },   // 后轮胎规格
                { name: '非全尺寸' },      // 备胎规格
                { name: '铝合金' },        // 轮毂材质
            ],
        },
        {
            key: 'safe',
            name: '安全装备',
            items: [
                { name: '●' },
                { name: '●' },
                { name: '●' },
                { name: '●' },
                { name: '●' },
                { name: '●' },
                { name: '-' },
                { name: '-' },
            ],
        },
        {
            key: 'assist',
            name: '辅助操控',
            items: [
                { name: '前●/后●' },
                { name: '●' },
                { name: '●' },
                { name: '-' },
                { name: '-' },
                { name: '●' },
                { name: '-' },
            ],
        },
        {
            key: 'external',
            name: '外部配置',
            items: [
                { name: '●' },
                { name: '-' },
                { name: '-' },
                { name: '-' },
                { name: '-' },
                { name: '●' },
                { name: '●' },
            ],
        },
        {
            key: 'internal',
            name: '内部配置',
            items: [
                { name: '●' },
                { name: '-' },
                { name: '●' },
                { name: '-' },
                { name: '-' },
                { name: '●' },
            ],
        },
        {
            key: 'seat',
            name: '座椅配置',
            items: [
                { name: '仿皮' },
                { name: '●' },
                { name: '●' },
                { name: '-' },
                { name: '-' },
                { name: '-' },
                { name: '●' },
            ],
        },
        {
            key: 'media',
            name: '多媒体',
            items: [
                { name: '12.3英寸' },    // 中控彩色屏
                { name: '●' },           // GPS导航
                { name: '●' },           // 道路救援
                { name: '●' },           // 蓝牙/车载电话
                { name: '●' },           // 车联网
                { name: '●' },           // OTA升级
                { name: '-' },           // 音响品牌 (无品牌)
                { name: '8喇叭' },       // 扬声器数量
            ],
        },
        {
            key: 'air',
            name: '空调/冰箱',
            items: [
                { name: '●' },
                { name: '-' },
                { name: '●' },
                { name: '●' },
                { name: '-' },
                { name: '●' },
            ],
        },]
    },
    {
        key: 'model2', name: '2025款 舒享版', Arr: [{
            key: 'base',
            name: '基础参数',
            items: [
                { name: '4980' },        // 车身长度(mm)
                { name: '1862' },        // 车身宽度(mm)
                { name: '1449' },        // 车身高度(mm)
                { name: '2830' },        // 轴距(mm)
                { name: '1591' },        // 前轮距(mm)
                { name: '1603' },        // 后轮距(mm)
                { name: '110' },         // 最小离地间隙(mm)
                { name: '1495' },        // 整备质量(kg)
            ],
        },
        {
            key: 'power',
            name: '动力系统',
            items: [
                { name: 'L15BN' },       // 发动机型号
                { name: '1498' },        // 排量(mL)
                { name: '涡轮增压' },     // 进气形式
                { name: '192' },         // 最大马力(Ps)
                { name: '260' },         // 最大扭矩(N·m)
                { name: 'CVT无级变速' },  // 变速箱类型
                { name: '无级变速' },     // 挡位个数
                { name: '前置前驱' },     // 驱动方式
                { name: '-' },           // 四驱形式 (无)
                { name: '-' },           // 中央差速器结构 (无)
            ],
        },
        {
            key: 'chassis',
            name: '底盘转向',
            items: [
                { name: '麦弗逊式独立悬架' },    // 前悬挂类型
                { name: '多连杆式独立悬架' },    // 后悬挂类型
                { name: '电动助力' },            // 助力类型
                { name: '承载式' },              // 车体结构
                { name: '通风盘式' },            // 前制动器类型
                { name: '盘式' },               // 后制动器类型
            ],
        },
        {
            key: 'wheel',
            name: '车轮制动',
            items: [
                { name: '235/45 R18' },   // 前轮胎规格
                { name: '235/45 R18' },   // 后轮胎规格
                { name: '非全尺寸' },      // 备胎规格
                { name: '铝合金' },        // 轮毂材质
            ],
        },
        {
            key: 'safe',
            name: '安全装备',
            items: [
                { name: '●' },    // 主驾安全气囊 (有)
                { name: '●' },    // 副驾安全气囊
                { name: '●' },    // 前排侧气囊
                { name: '●' },    // 前后排头部气囊
                { name: '●' },    // 胎压监测
                { name: '●' },    // 车身稳定控制
                { name: '-' },    // 并线辅助 (无)
                { name: '-' },    // 车道偏离预警 (无，高配才有)
            ],
        },
        {
            key: 'assist',
            name: '辅助操控',
            items: [
                { name: '前●/后●' },    // 前后驻车雷达 (前有/后有)
                { name: '●' },           // 360°全景影像
                { name: '●' },           // 定速巡航
                { name: '-' },           // 自适应巡航 (无)
                { name: '-' },           // 自动泊车 (无)
                { name: '●' },           // 上坡辅助
                { name: '-' },           // 陡坡缓降 (无)
            ],
        },
        {
            key: 'external',
            name: '外部配置',
            items: [
                { name: '●' },        // 全景天窗
                { name: '-' },        // 运动外观套件
                { name: '-' },        // 电动后备箱
                { name: '-' },        // 感应后备箱
                { name: '-' },        // 车顶行李架
                { name: '●' },        // LED日间行车灯
                { name: '●' },        // 自动大灯
            ],
        },
        {
            key: 'internal',
            name: '内部配置',
            items: [
                { name: '●' },        // 真皮方向盘
                { name: '-' },        // 方向盘加热
                { name: '●' },        // 全液晶仪表
                { name: '-' },        // HUD抬头显示
                { name: '-' },        // 内置行车记录仪
                { name: '●' },        // 手机无线充电
            ],
        },
        {
            key: 'seat',
            name: '座椅配置',
            items: [
                { name: '仿皮' },     // 真皮座椅 (实际是仿皮)
                { name: '●' },        // 主驾电动调节
                { name: '●' },        // 副驾电动调节
                { name: '-' },        // 前排座椅加热 (无)
                { name: '-' },        // 前排座椅通风 (无)
                { name: '-' },        // 后排座椅加热 (无)
                { name: '●' },        // 后排杯架
            ],
        },
        {
            key: 'media',
            name: '多媒体',
            items: [
                { name: '12.3英寸' },    // 中控彩色屏
                { name: '●' },           // GPS导航
                { name: '●' },           // 道路救援
                { name: '●' },           // 蓝牙/车载电话
                { name: '●' },           // 车联网
                { name: '●' },           // OTA升级
                { name: '-' },           // 音响品牌 (无品牌)
                { name: '8喇叭' },       // 扬声器数量
            ],
        },
        {
            key: 'air',
            name: '空调/冰箱',
            items: [
                { name: '●' },        // 自动空调
                { name: '-' },        // 后排独立空调
                { name: '●' },        // 后座出风口
                { name: '●' },        // 温度分区控制
                { name: '-' },        // 车载空气净化器
                { name: '●' },        // 车内PM2.5过滤
            ],
        },]
    },
    {
        key: 'model3', name: '2025款 尊享版', Arr: [{
            key: 'base',
            name: '基础参数',
            items: [
                { name: '4980' },        // 车身长度(mm)
                { name: '1862' },        // 车身宽度(mm)
                { name: '1449' },        // 车身高度(mm)
                { name: '2830' },        // 轴距(mm)
                { name: '1591' },        // 前轮距(mm)
                { name: '1603' },        // 后轮距(mm)
                { name: '110' },         // 最小离地间隙(mm)
                { name: '1495' },        // 整备质量(kg)
            ],
        },
        {
            key: 'power',
            name: '动力系统',
            items: [
                { name: 'L15BN' },       // 发动机型号
                { name: '1498' },        // 排量(mL)
                { name: '涡轮增压' },     // 进气形式
                { name: '192' },         // 最大马力(Ps)
                { name: '260' },         // 最大扭矩(N·m)
                { name: 'CVT无级变速' },  // 变速箱类型
                { name: '无级变速' },     // 挡位个数
                { name: '前置前驱' },     // 驱动方式
                { name: '-' },           // 四驱形式 (无)
                { name: '-' },           // 中央差速器结构 (无)
            ],
        },
        {
            key: 'chassis',
            name: '底盘转向',
            items: [
                { name: '麦弗逊式独立悬架' },    // 前悬挂类型
                { name: '多连杆式独立悬架' },    // 后悬挂类型
                { name: '电动助力' },            // 助力类型
                { name: '承载式' },              // 车体结构
                { name: '通风盘式' },            // 前制动器类型
                { name: '盘式' },               // 后制动器类型
            ],
        },
        {
            key: 'wheel',
            name: '车轮制动',
            items: [
                { name: '235/45 R18' },   // 前轮胎规格
                { name: '235/45 R18' },   // 后轮胎规格
                { name: '非全尺寸' },      // 备胎规格
                { name: '铝合金' },        // 轮毂材质
            ],
        },
        {
            key: 'safe',
            name: '安全装备',
            items: [
                { name: '●' },    // 主驾安全气囊 (有)
                { name: '●' },    // 副驾安全气囊
                { name: '●' },    // 前排侧气囊
                { name: '●' },    // 前后排头部气囊
                { name: '●' },    // 胎压监测
                { name: '●' },    // 车身稳定控制
                { name: '-' },    // 并线辅助 (无)
                { name: '-' },    // 车道偏离预警 (无，高配才有)
            ],
        },
        {
            key: 'assist',
            name: '辅助操控',
            items: [
                { name: '前●/后●' },    // 前后驻车雷达 (前有/后有)
                { name: '●' },           // 360°全景影像
                { name: '●' },           // 定速巡航
                { name: '-' },           // 自适应巡航 (无)
                { name: '-' },           // 自动泊车 (无)
                { name: '●' },           // 上坡辅助
                { name: '-' },           // 陡坡缓降 (无)
            ],
        },
        {
            key: 'external',
            name: '外部配置',
            items: [
                { name: '●' },        // 全景天窗
                { name: '-' },        // 运动外观套件
                { name: '-' },        // 电动后备箱
                { name: '-' },        // 感应后备箱
                { name: '-' },        // 车顶行李架
                { name: '●' },        // LED日间行车灯
                { name: '●' },        // 自动大灯
            ],
        },
        {
            key: 'internal',
            name: '内部配置',
            items: [
                { name: '●' },        // 真皮方向盘
                { name: '-' },        // 方向盘加热
                { name: '●' },        // 全液晶仪表
                { name: '-' },        // HUD抬头显示
                { name: '-' },        // 内置行车记录仪
                { name: '●' },        // 手机无线充电
            ],
        },
        {
            key: 'seat',
            name: '座椅配置',
            items: [
                { name: '仿皮' },     // 真皮座椅 (实际是仿皮)
                { name: '●' },        // 主驾电动调节
                { name: '●' },        // 副驾电动调节
                { name: '-' },        // 前排座椅加热 (无)
                { name: '-' },        // 前排座椅通风 (无)
                { name: '-' },        // 后排座椅加热 (无)
                { name: '●' },        // 后排杯架
            ],
        },
        {
            key: 'media',
            name: '多媒体',
            items: [
                { name: '12.3英寸' },    // 中控彩色屏
                { name: '●' },           // GPS导航
                { name: '●' },           // 道路救援
                { name: '●' },           // 蓝牙/车载电话
                { name: '●' },           // 车联网
                { name: '●' },           // OTA升级
                { name: '-' },           // 音响品牌 (无品牌)
                { name: '8喇叭' },       // 扬声器数量
            ],
        },
        {
            key: 'air',
            name: '空调/冰箱',
            items: [
                { name: '●' },        // 自动空调
                { name: '-' },        // 后排独立空调
                { name: '●' },        // 后座出风口
                { name: '●' },        // 温度分区控制
                { name: '-' },        // 车载空气净化器
                { name: '●' },        // 车内PM2.5过滤
            ],
        },]
    },
    {
        key: 'model4', name: '2025款 旗舰版', Arr: [{
            key: 'base',
            name: '基础参数',
            items: [
                { name: '4980' },        // 车身长度(mm)
                { name: '1862' },        // 车身宽度(mm)
                { name: '1449' },        // 车身高度(mm)
                { name: '2830' },        // 轴距(mm)
                { name: '1591' },        // 前轮距(mm)
                { name: '1603' },        // 后轮距(mm)
                { name: '110' },         // 最小离地间隙(mm)
                { name: '1495' },        // 整备质量(kg)
            ],
        },
        {
            key: 'power',
            name: '动力系统',
            items: [
                { name: 'L15BN' },       // 发动机型号
                { name: '1498' },        // 排量(mL)
                { name: '涡轮增压' },     // 进气形式
                { name: '192' },         // 最大马力(Ps)
                { name: '260' },         // 最大扭矩(N·m)
                { name: 'CVT无级变速' },  // 变速箱类型
                { name: '无级变速' },     // 挡位个数
                { name: '前置前驱' },     // 驱动方式
                { name: '-' },           // 四驱形式 (无)
                { name: '-' },           // 中央差速器结构 (无)
            ],
        },
        {
            key: 'chassis',
            name: '底盘转向',
            items: [
                { name: '麦弗逊式独立悬架' },    // 前悬挂类型
                { name: '多连杆式独立悬架' },    // 后悬挂类型
                { name: '电动助力' },            // 助力类型
                { name: '承载式' },              // 车体结构
                { name: '通风盘式' },            // 前制动器类型
                { name: '盘式' },               // 后制动器类型
            ],
        },
        {
            key: 'wheel',
            name: '车轮制动',
            items: [
                { name: '235/45 R18' },   // 前轮胎规格
                { name: '235/45 R18' },   // 后轮胎规格
                { name: '非全尺寸' },      // 备胎规格
                { name: '铝合金' },        // 轮毂材质
            ],
        },
        {
            key: 'safe',
            name: '安全装备',
            items: [
                { name: '●' },    // 主驾安全气囊 (有)
                { name: '●' },    // 副驾安全气囊
                { name: '●' },    // 前排侧气囊
                { name: '●' },    // 前后排头部气囊
                { name: '●' },    // 胎压监测
                { name: '●' },    // 车身稳定控制
                { name: '-' },    // 并线辅助 (无)
                { name: '-' },    // 车道偏离预警 (无，高配才有)
            ],
        },
        {
            key: 'assist',
            name: '辅助操控',
            items: [
                { name: '前●/后●' },    // 前后驻车雷达 (前有/后有)
                { name: '●' },           // 360°全景影像
                { name: '●' },           // 定速巡航
                { name: '-' },           // 自适应巡航 (无)
                { name: '-' },           // 自动泊车 (无)
                { name: '●' },           // 上坡辅助
                { name: '-' },           // 陡坡缓降 (无)
            ],
        },
        {
            key: 'external',
            name: '外部配置',
            items: [
                { name: '●' },        // 全景天窗
                { name: '-' },        // 运动外观套件
                { name: '-' },        // 电动后备箱
                { name: '-' },        // 感应后备箱
                { name: '-' },        // 车顶行李架
                { name: '●' },        // LED日间行车灯
                { name: '●' },        // 自动大灯
            ],
        },
        {
            key: 'internal',
            name: '内部配置',
            items: [
                { name: '●' },        // 真皮方向盘
                { name: '-' },        // 方向盘加热
                { name: '●' },        // 全液晶仪表
                { name: '-' },        // HUD抬头显示
                { name: '-' },        // 内置行车记录仪
                { name: '●' },        // 手机无线充电
            ],
        },
        {
            key: 'seat',
            name: '座椅配置',
            items: [
                { name: '仿皮' },     // 真皮座椅 (实际是仿皮)
                { name: '●' },        // 主驾电动调节
                { name: '●' },        // 副驾电动调节
                { name: '-' },        // 前排座椅加热 (无)
                { name: '-' },        // 前排座椅通风 (无)
                { name: '-' },        // 后排座椅加热 (无)
                { name: '●' },        // 后排杯架
            ],
        },
        {
            key: 'media',
            name: '多媒体',
            items: [
                { name: '12.3英寸' },    // 中控彩色屏
                { name: '●' },           // GPS导航
                { name: '●' },           // 道路救援
                { name: '●' },           // 蓝牙/车载电话
                { name: '●' },           // 车联网
                { name: '●' },           // OTA升级
                { name: '-' },           // 音响品牌 (无品牌)
                { name: '8喇叭' },       // 扬声器数量
            ],
        },
        {
            key: 'air',
            name: '空调/冰箱',
            items: [
                { name: '●' },        // 自动空调
                { name: '-' },        // 后排独立空调
                { name: '●' },        // 后座出风口
                { name: '●' },        // 温度分区控制
                { name: '-' },        // 车载空气净化器
                { name: '●' },        // 车内PM2.5过滤
            ],
        },]
    },
    {
        key: 'model5', name: '2025款 至尊版', Arr: [{
            key: 'base',
            name: '基础参数',
            items: [
                { name: '4980' },        // 车身长度(mm)
                { name: '1862' },        // 车身宽度(mm)
                { name: '1449' },        // 车身高度(mm)
                { name: '2830' },        // 轴距(mm)
                { name: '1591' },        // 前轮距(mm)
                { name: '1603' },        // 后轮距(mm)
                { name: '110' },         // 最小离地间隙(mm)
                { name: '1495' },        // 整备质量(kg)
            ],
        },
        {
            key: 'power',
            name: '动力系统',
            items: [
                { name: 'L15BN' },       // 发动机型号
                { name: '1498' },        // 排量(mL)
                { name: '涡轮增压' },     // 进气形式
                { name: '192' },         // 最大马力(Ps)
                { name: '260' },         // 最大扭矩(N·m)
                { name: 'CVT无级变速' },  // 变速箱类型
                { name: '无级变速' },     // 挡位个数
                { name: '前置前驱' },     // 驱动方式
                { name: '-' },           // 四驱形式 (无)
                { name: '-' },           // 中央差速器结构 (无)
            ],
        },
        {
            key: 'chassis',
            name: '底盘转向',
            items: [
                { name: '麦弗逊式独立悬架' },    // 前悬挂类型
                { name: '多连杆式独立悬架' },    // 后悬挂类型
                { name: '电动助力' },            // 助力类型
                { name: '承载式' },              // 车体结构
                { name: '通风盘式' },            // 前制动器类型
                { name: '盘式' },               // 后制动器类型
            ],
        },
        {
            key: 'wheel',
            name: '车轮制动',
            items: [
                { name: '235/45 R18' },   // 前轮胎规格
                { name: '235/45 R18' },   // 后轮胎规格
                { name: '非全尺寸' },      // 备胎规格
                { name: '铝合金' },        // 轮毂材质
            ],
        },
        {
            key: 'safe',
            name: '安全装备',
            items: [
                { name: '●' },    // 主驾安全气囊 (有)
                { name: '●' },    // 副驾安全气囊
                { name: '●' },    // 前排侧气囊
                { name: '●' },    // 前后排头部气囊
                { name: '●' },    // 胎压监测
                { name: '●' },    // 车身稳定控制
                { name: '-' },    // 并线辅助 (无)
                { name: '-' },    // 车道偏离预警 (无，高配才有)
            ],
        },
        {
            key: 'assist',
            name: '辅助操控',
            items: [
                { name: '前●/后●' },    // 前后驻车雷达 (前有/后有)
                { name: '●' },           // 360°全景影像
                { name: '●' },           // 定速巡航
                { name: '-' },           // 自适应巡航 (无)
                { name: '-' },           // 自动泊车 (无)
                { name: '●' },           // 上坡辅助
                { name: '-' },           // 陡坡缓降 (无)
            ],
        },
        {
            key: 'external',
            name: '外部配置',
            items: [
                { name: '●' },        // 全景天窗
                { name: '-' },        // 运动外观套件
                { name: '-' },        // 电动后备箱
                { name: '-' },        // 感应后备箱
                { name: '-' },        // 车顶行李架
                { name: '●' },        // LED日间行车灯
                { name: '●' },        // 自动大灯
            ],
        },
        {
            key: 'internal',
            name: '内部配置',
            items: [
                { name: '●' },        // 真皮方向盘
                { name: '-' },        // 方向盘加热
                { name: '●' },        // 全液晶仪表
                { name: '-' },        // HUD抬头显示
                { name: '-' },        // 内置行车记录仪
                { name: '●' },        // 手机无线充电
            ],
        },
        {
            key: 'seat',
            name: '座椅配置',
            items: [
                { name: '仿皮' },     // 真皮座椅 (实际是仿皮)
                { name: '●' },        // 主驾电动调节
                { name: '●' },        // 副驾电动调节
                { name: '-' },        // 前排座椅加热 (无)
                { name: '-' },        // 前排座椅通风 (无)
                { name: '-' },        // 后排座椅加热 (无)
                { name: '●' },        // 后排杯架
            ],
        },
        {
            key: 'media',
            name: '多媒体',
            items: [
                { name: '12.3英寸' },    // 中控彩色屏
                { name: '●' },           // GPS导航
                { name: '●' },           // 道路救援
                { name: '●' },           // 蓝牙/车载电话
                { name: '●' },           // 车联网
                { name: '●' },           // OTA升级
                { name: '-' },           // 音响品牌 (无品牌)
                { name: '8喇叭' },       // 扬声器数量
            ],
        },
        {
            key: 'air',
            name: '空调/冰箱',
            items: [
                { name: '●' },        // 自动空调
                { name: '-' },        // 后排独立空调
                { name: '●' },        // 后座出风口
                { name: '●' },        // 温度分区控制
                { name: '-' },        // 车载空气净化器
                { name: '●' },        // 车内PM2.5过滤
            ],
        },]
    },


];

export let configList1 = [
    {
        key: 'base',
        name: '基础参数',
        items: ['车身长度(mm)', '车身宽度(mm)', '车身高度(mm)', '轴距(mm)', '前轮距(mm)', '后轮距(mm)', '最小离地间隙(mm)', '整备质量(kg)'].map(n => ({ name: n }))
    },
    {
        key: 'power',
        name: '动力系统',
        items: ['发动机型号', '排量(mL)', '进气形式', '最大马力(Ps)', '最大扭矩(N·m)', '变速箱类型', '挡位个数', '驱动方式', '四驱形式', '中央差速器结构'].map(n => ({ name: n }))
    },
    {
        key: 'chassis',
        name: '底盘转向',
        items: ['前悬挂类型', '后悬挂类型', '助力类型', '车体结构', '前制动器类型', '后制动器类型'].map(n => ({ name: n }))
    },
    {
        key: 'wheel',
        name: '车轮制动',
        items: ['前轮胎规格', '后轮胎规格', '备胎规格', '轮毂材质'].map(n => ({ name: n }))
    },
    {
        key: 'safe',
        name: '安全装备',
        items: ['主驾安全气囊', '副驾安全气囊', '前排侧气囊', '前后排头部气囊', '胎压监测', '车身稳定控制', '并线辅助', '车道偏离预警'].map(n => ({ name: n }))
    },
    {
        key: 'assist',
        name: '辅助操控',
        items: ['前后驻车雷达', '360°全景影像', '定速巡航', '自适应巡航', '自动泊车', '上坡辅助', '陡坡缓降'].map(n => ({ name: n }))
    },
    {
        key: 'external',
        name: '外部配置',
        items: ['全景天窗', '运动外观套件', '电动后备箱', '感应后备箱', '车顶行李架', 'LED日间行车灯', '自动大灯'].map(n => ({ name: n }))
    },
    {
        key: 'internal',
        name: '内部配置',
        items: ['真皮方向盘', '方向盘加热', '全液晶仪表', 'HUD抬头显示', '内置行车记录仪', '手机无线充电'].map(n => ({ name: n }))
    },
    {
        key: 'seat',
        name: '座椅配置',
        items: ['真皮座椅', '主驾电动调节', '副驾电动调节', '前排座椅加热', '前排座椅通风', '后排座椅加热', '后排杯架'].map(n => ({ name: n }))
    },
    {
        key: 'media',
        name: '多媒体',
        items: ['中控彩色屏', 'GPS导航', '道路救援', '蓝牙/车载电话', '车联网', 'OTA升级', '音响品牌', '扬声器数量'].map(n => ({ name: n }))
    },
    {
        key: 'air',
        name: '空调/冰箱',
        items: ['自动空调', '后排独立空调', '后座出风口', '温度分区控制', '车载空气净化器', '车内PM2.5过滤'].map(n => ({ name: n }))
    }
]

export let defaultConfigList3 = [
    {
        key: 'model1',
        name: '2025款 畅享版',
        Arr: [
            {
                key: 'base',
                items: [{ name: '4980' }, { name: '1862' }, { name: '1449' }, { name: '2830' }, { name: '1591' }, { name: '1603' }, { name: '110' }, { name: '1495' }]
            },
            {
                key: 'power',
                items: [{ name: 'L15BN' }, { name: '1498' }, { name: '涡轮增压' }, { name: '192' }, { name: '260' }, { name: 'CVT无级变速' }, { name: '无级变速' }, { name: '前置前驱' }, { name: '-' }, { name: '-' }]
            },
            {
                key: 'chassis',
                items: [{ name: '麦弗逊式独立悬架' }, { name: '多连杆式独立悬架' }, { name: '电动助力' }, { name: '承载式' }, { name: '通风盘式' }, { name: '盘式' }]
            },
            {
                key: 'wheel',
                items: [{ name: '235/45 R18' }, { name: '235/45 R18' }, { name: '非全尺寸' }, { name: '铝合金' }]
            },
            {
                key: 'safe',
                items: [{ name: '●' }, { name: '●' }, { name: '●' }, { name: '●' }, { name: '●' }, { name: '●' }, { name: '-' }, { name: '-' }]
            },
            {
                key: 'assist',
                items: [{ name: '前●/后●' }, { name: '●' }, { name: '●' }, { name: '-' }, { name: '-' }, { name: '●' }, { name: '-' }]
            },
            {
                key: 'external',
                items: [{ name: '●' }, { name: '-' }, { name: '-' }, { name: '-' }, { name: '-' }, { name: '●' }, { name: '●' }]
            },
            {
                key: 'internal',
                items: [{ name: '●' }, { name: '-' }, { name: '●' }, { name: '-' }, { name: '-' }, { name: '●' }]
            },
            {
                key: 'seat',
                items: [{ name: '仿皮' }, { name: '●' }, { name: '●' }, { name: '-' }, { name: '-' }, { name: '-' }, { name: '●' }]
            },
            {
                key: 'media',
                items: [{ name: '12.3英寸' }, { name: '●' }, { name: '●' }, { name: '●' }, { name: '●' }, { name: '●' }, { name: '-' }, { name: '8喇叭' }]
            },
            {
                key: 'air',
                items: [{ name: '●' }, { name: '-' }, { name: '●' }, { name: '●' }, { name: '-' }, { name: '●' }]
            }
        ]
    },
    {
        key: 'model2',
        name: '2025款 舒享版',
        Arr: [
            {
                key: 'base',
                items: [{ name: '4980' }, { name: '1862' }, { name: '1449' }, { name: '2830' }, { name: '1591' }, { name: '1603' }, { name: '110' }, { name: '1495' }]
            },
            {
                key: 'power',
                items: [{ name: 'L15BN' }, { name: '1498' }, { name: '涡轮增压' }, { name: '192' }, { name: '260' }, { name: 'CVT无级变速' }, { name: '无级变速' }, { name: '前置前驱' }, { name: '-' }, { name: '-' }]
            },
            {
                key: 'chassis',
                items: [{ name: '麦弗逊式独立悬架' }, { name: '多连杆式独立悬架' }, { name: '电动助力' }, { name: '承载式' }, { name: '通风盘式' }, { name: '盘式' }]
            },
            {
                key: 'wheel',
                items: [{ name: '235/45 R18' }, { name: '235/45 R18' }, { name: '非全尺寸' }, { name: '铝合金' }]
            },
            {
                key: 'safe',
                items: [{ name: '●' }, { name: '●' }, { name: '●' }, { name: '●' }, { name: '●' }, { name: '●' }, { name: '-' }, { name: '-' }]
            },
            {
                key: 'assist',
                items: [{ name: '前●/后●' }, { name: '●' }, { name: '●' }, { name: '-' }, { name: '-' }, { name: '●' }, { name: '-' }]
            },
            {
                key: 'external',
                items: [{ name: '●' }, { name: '-' }, { name: '-' }, { name: '-' }, { name: '-' }, { name: '●' }, { name: '●' }]
            },
            {
                key: 'internal',
                items: [{ name: '●' }, { name: '-' }, { name: '●' }, { name: '-' }, { name: '-' }, { name: '●' }]
            },
            {
                key: 'seat',
                items: [{ name: '仿皮' }, { name: '●' }, { name: '●' }, { name: '-' }, { name: '-' }, { name: '-' }, { name: '●' }]
            },
            {
                key: 'media',
                items: [{ name: '12.3英寸' }, { name: '●' }, { name: '●' }, { name: '●' }, { name: '●' }, { name: '●' }, { name: '-' }, { name: '8喇叭' }]
            },
            {
                key: 'air',
                items: [{ name: '●' }, { name: '-' }, { name: '●' }, { name: '●' }, { name: '-' }, { name: '●' }]
            }
        ]
    },
    {
        key: 'model3',
        name: '2025款 尊享版',
        Arr: [
            {
                key: 'base',
                items: [{ name: '4980' }, { name: '1862' }, { name: '1449' }, { name: '2830' }, { name: '1591' }, { name: '1603' }, { name: '110' }, { name: '1495' }]
            },
            {
                key: 'power',
                items: [{ name: 'L15BN' }, { name: '1498' }, { name: '涡轮增压' }, { name: '192' }, { name: '260' }, { name: 'CVT无级变速' }, { name: '无级变速' }, { name: '前置前驱' }, { name: '-' }, { name: '-' }]
            },
            {
                key: 'chassis',
                items: [{ name: '麦弗逊式独立悬架' }, { name: '多连杆式独立悬架' }, { name: '电动助力' }, { name: '承载式' }, { name: '通风盘式' }, { name: '盘式' }]
            },
            {
                key: 'wheel',
                items: [{ name: '235/45 R18' }, { name: '235/45 R18' }, { name: '非全尺寸' }, { name: '铝合金' }]
            },
            {
                key: 'safe',
                items: [{ name: '●' }, { name: '●' }, { name: '●' }, { name: '●' }, { name: '●' }, { name: '●' }, { name: '-' }, { name: '-' }]
            },
            {
                key: 'assist',
                items: [{ name: '前●/后●' }, { name: '●' }, { name: '●' }, { name: '-' }, { name: '-' }, { name: '●' }, { name: '-' }]
            },
            {
                key: 'external',
                items: [{ name: '●' }, { name: '-' }, { name: '-' }, { name: '-' }, { name: '-' }, { name: '●' }, { name: '●' }]
            },
            {
                key: 'internal',
                items: [{ name: '●' }, { name: '-' }, { name: '●' }, { name: '-' }, { name: '-' }, { name: '●' }]
            },
            {
                key: 'seat',
                items: [{ name: '仿皮' }, { name: '●' }, { name: '●' }, { name: '-' }, { name: '-' }, { name: '-' }, { name: '●' }]
            },
            {
                key: 'media',
                items: [{ name: '12.3英寸' }, { name: '●' }, { name: '●' }, { name: '●' }, { name: '●' }, { name: '●' }, { name: '-' }, { name: '8喇叭' }]
            },
            {
                key: 'air',
                items: [{ name: '●' }, { name: '-' }, { name: '●' }, { name: '●' }, { name: '-' }, { name: '●' }]
            }
        ]
    },
    {
        key: 'model4',
        name: '2025款 旗舰版',
        Arr: [
            {
                key: 'base',
                items: [{ name: '4980' }, { name: '1862' }, { name: '1449' }, { name: '2830' }, { name: '1591' }, { name: '1603' }, { name: '110' }, { name: '1495' }]
            },
            {
                key: 'power',
                items: [{ name: 'L15BN' }, { name: '1498' }, { name: '涡轮增压' }, { name: '192' }, { name: '260' }, { name: 'CVT无级变速' }, { name: '无级变速' }, { name: '前置前驱' }, { name: '-' }, { name: '-' }]
            },
            {
                key: 'chassis',
                items: [{ name: '麦弗逊式独立悬架' }, { name: '多连杆式独立悬架' }, { name: '电动助力' }, { name: '承载式' }, { name: '通风盘式' }, { name: '盘式' }]
            },
            {
                key: 'wheel',
                items: [{ name: '235/45 R18' }, { name: '235/45 R18' }, { name: '非全尺寸' }, { name: '铝合金' }]
            },
            {
                key: 'safe',
                items: [{ name: '●' }, { name: '●' }, { name: '●' }, { name: '●' }, { name: '●' }, { name: '●' }, { name: '-' }, { name: '-' }]
            },
            {
                key: 'assist',
                items: [{ name: '前●/后●' }, { name: '●' }, { name: '●' }, { name: '-' }, { name: '-' }, { name: '●' }, { name: '-' }]
            },
            {
                key: 'external',
                items: [{ name: '●' }, { name: '-' }, { name: '-' }, { name: '-' }, { name: '-' }, { name: '●' }, { name: '●' }]
            },
            {
                key: 'internal',
                items: [{ name: '●' }, { name: '-' }, { name: '●' }, { name: '-' }, { name: '-' }, { name: '●' }]
            },
            {
                key: 'seat',
                items: [{ name: '仿皮' }, { name: '●' }, { name: '●' }, { name: '-' }, { name: '-' }, { name: '-' }, { name: '●' }]
            },
            {
                key: 'media',
                items: [{ name: '12.3英寸' }, { name: '●' }, { name: '●' }, { name: '●' }, { name: '●' }, { name: '●' }, { name: '-' }, { name: '8喇叭' }]
            },
            {
                key: 'air',
                items: [{ name: '●' }, { name: '-' }, { name: '●' }, { name: '●' }, { name: '-' }, { name: '●' }]
            }
        ]
    },
    {
        key: 'model5',
        name: '2025款 至尊版',
        Arr: [
            {
                key: 'base',
                items: [{ name: '4980' }, { name: '1862' }, { name: '1449' }, { name: '2830' }, { name: '1591' }, { name: '1603' }, { name: '110' }, { name: '1495' }]
            },
            {
                key: 'power',
                items: [{ name: 'L15BN' }, { name: '1498' }, { name: '涡轮增压' }, { name: '192' }, { name: '260' }, { name: 'CVT无级变速' }, { name: '无级变速' }, { name: '前置前驱' }, { name: '-' }, { name: '-' }]
            },
            {
                key: 'chassis',
                items: [{ name: '麦弗逊式独立悬架' }, { name: '多连杆式独立悬架' }, { name: '电动助力' }, { name: '承载式' }, { name: '通风盘式' }, { name: '盘式' }]
            },
            {
                key: 'wheel',
                items: [{ name: '235/45 R18' }, { name: '235/45 R18' }, { name: '非全尺寸' }, { name: '铝合金' }]
            },
            {
                key: 'safe',
                items: [{ name: '●' }, { name: '●' }, { name: '●' }, { name: '●' }, { name: '●' }, { name: '●' }, { name: '-' }, { name: '-' }]
            },
            {
                key: 'assist',
                items: [{ name: '前●/后●' }, { name: '●' }, { name: '●' }, { name: '-' }, { name: '-' }, { name: '●' }, { name: '-' }]
            },
            {
                key: 'external',
                items: [{ name: '●' }, { name: '-' }, { name: '-' }, { name: '-' }, { name: '-' }, { name: '●' }, { name: '●' }]
            },
            {
                key: 'internal',
                items: [{ name: '●' }, { name: '-' }, { name: '●' }, { name: '-' }, { name: '-' }, { name: '●' }]
            },
            {
                key: 'seat',
                items: [{ name: '仿皮' }, { name: '●' }, { name: '●' }, { name: '-' }, { name: '-' }, { name: '-' }, { name: '●' }]
            },
            {
                key: 'media',
                items: [{ name: '12.3英寸' }, { name: '●' }, { name: '●' }, { name: '●' }, { name: '●' }, { name: '●' }, { name: '-' }, { name: '8喇叭' }]
            },
            {
                key: 'air',
                items: [{ name: '●' }, { name: '-' }, { name: '●' }, { name: '●' }, { name: '-' }, { name: '●' }]
            }
        ]
    }
]